// extracted by mini-css-extract-plugin
export var social_module = "SocialMediaSection-module--social_module--8svIP";
export var social_row = "SocialMediaSection-module--social_row--Cqyxh";